import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshSub = useCallback(async () => {
    try {
      const res = await api.get("/subscription");
      setSub(res.data);
      return res.data;
    } catch {
      setSub(null);
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      await refreshSub();
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [refreshSub]);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
    setSub(null);
    window.location.href = "/login";
  };

  const plan = sub?.plan || "free";
  const isPaid = plan === "pro" || plan === "agency";
  const isAdmin = !!user?.is_admin;

  return (
    <AuthContext.Provider value={{ user, setUser, sub, plan, isPaid, isAdmin, refreshSub, loading, checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
